export default {
  "config": {
    "trial": "tones-5",
    "id": "study-design",
    "type": "design",
    "title": "TONES 5 Study Design Including Titration Phase, Maintenance Phase, RW Phase, and Safety Follow-Up<sup>14</sup>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "Group A included participants who completed a phase 3, 12-week narcolepsy (NCT02348593)<sup>28</sup> or OSA (NCT02348606)<sup>23</sup> study, and who immediately enrolled into this long term study; the study duration in this group was for 40 weeks.",
      "Group B included participants with narcolepsy or OSA who completed one of the phase 2 studies (NCT01485770, NCT01681121, NCT0286908, and NCT02806895)<sup>5,21</sup> or the 6-week, phase 3 study (NCT02348619)<sup>25</sup> and were subsequently enrolled into this long-term study. These participants had a study duration for 52 weeks."
    ],
    "useFootnoteTooltip": true
  },
  "data": {
    "trial": "tones-5",
    "id": "study-design",
    "data-type": "design",
    "title": "TONES 5 Study Design Including Titration Phase, Maintenance Phase, RW Phase, and Safety Follow-Up<sup>14</sup>",
    "footnote-tooltip": "enable",
    "footnote-order": [
      "footnote-note1",
      "footnote-note2",
      "footnote-note3"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
    "footnote-note2": "Group A included participants who completed a phase 3, 12-week narcolepsy (NCT02348593)<sup>28</sup> or OSA (NCT02348606)<sup>23</sup> study, and who immediately enrolled into this long term study; the study duration in this group was for 40 weeks.",
    "footnote-note3": "Group B included participants with narcolepsy or OSA who completed one of the phase 2 studies (NCT01485770, NCT01681121, NCT0286908, and NCT02806895)<sup>5,21</sup> or the 6-week, phase 3 study (NCT02348619)<sup>25</sup> and were subsequently enrolled into this long-term study. These participants had a study duration for 52 weeks."
  }
};